import { BifrostBackendApi, BifrostBackendNestApi, BifrostBackendViaCdnApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
const tenantId = appConfig.tenantId;

export default {
	getServerData(useApiCdnCaching) {
		return (useApiCdnCaching ? BifrostBackendViaCdnApi : BifrostBackendApi).get("/monitoring", {
			params: {
				tenantId
			}
		}).then((response => {
			return response.data;
		}));
	},

	async setServerData({ settingName, settingValue, useBifrostNest, jwtToken }) {
		const response = useBifrostNest
			? await BifrostBackendNestApi.patch(`/tenants/${tenantId}`, {
				tenantSetting: 1,
				tenantSettingName: settingName,
				tenantSettingValue: settingValue
			}, { headers: { Authorization: jwtToken }})
			: await BifrostBackendApi.post("/monitoring", {
				tenantSetting: 1,
				tenantSettingName: settingName,
				tenantSettingValue: settingValue
			}, { headers: { Authorization: jwtToken }});

		return response.data;
	}
};
